module.exports = __webpack_public_path__ + "1155b8e67dad8018a8bcf4a62acfc24e.png";